import { apiRequest } from '../../apiCall'
import { GetReportCallQueueByDateForListQueuesPayload } from '../../interfaces/queue'
import { GetQueueCallReportByRecordNameRequest, GetQueueCallReportRequest, getReportCallQueueByDatePayload } from '../../types/callQueueReport/apiRequestType'


export const getCallQueueReport = (params: GetQueueCallReportRequest) => apiRequest('CallQueueReport.Search', params, '', true)

export const getCallQueueReportByRecordName = (params: GetQueueCallReportByRecordNameRequest) => apiRequest('CallQueueReport.GetCallQueueReportByRecordName', {}, "?RecordName=" + params, true)
export const getReportCallQueueByDateRequest = (params: getReportCallQueueByDatePayload) => apiRequest('CallQueueReport.ReportCallQueueByDate', { ...params.apiBody }, "?CallQueueId=" + params.callQueueId, true)
export const getReportActiveCallQueueRequest = (queueId: string) => apiRequest('CallQueueActiveCall.ReportActiveCallQueue', {}, "?QueueId=" + queueId, true)
export const getWeeklyReportCallQueueRequest = (queueId: string) => apiRequest('CallQueueReport.WeeklyReportCallQueue', {}, "?CallQueueId=" + queueId, true)

export const getReportCallQueueByDateForListQueuesRequest = (params: GetReportCallQueueByDateForListQueuesPayload) =>
    apiRequest('CallQueueReport.GetReportCallQueueByDateForListQueues', { ...params }, "", true)
export const getReportActiveCallForAllQueueRequest = (queueIds: string[]) => apiRequest('CallQueueActiveCall.GetReportActiveCallForAllQueue', queueIds, "", true)





